module.exports = __webpack_public_path__ + "static/media/Prenomina.cb48f422.svg";